export const ENUM_EVENT_NAME = {
  GET_STARTED: 'get_started',
  GET_SDK: 'get_sdk',
  CONTACT_US: 'contact_us',
  ANDROID_DOC: 'android_doc',
  UNITY_DOC: 'unity_doc',
  IOS_DOC: 'ios_doc',
  OPERATION_GUIDE: 'operation_guide',
  EXPLORE_NOW: 'explore_now'
}
